import React from 'react';

/**
 * A stated gap, never a dash. "—" reads the same for "no price", "no unit" and
 * "no vendor"; naming the gap tells the reader which one to go and fix.
 */
export interface MissingValueProps {
  label?: string;
  /** Slightly smaller text, for dense rows. */
  compact?: boolean;
}

const MissingValue: React.FC<MissingValueProps> = ({ label = 'missing', compact }) => (
  <span
    style={{
      color: '#d48806', // antd warning-6 — readable on light and dark surfaces
      fontSize: compact ? 11.5 : 12,
      whiteSpace: 'nowrap',
    }}
  >
    {label}
  </span>
);

export default MissingValue;
